var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 7.5C23.3496 7.5 17.3877 10.4004 13.2715 15H9.375C4.2041 15 0 19.2041 0 24.375V35.625C0 40.7959 4.2041 45 9.375 45H13.2715C17.3877 49.5996 23.3496 52.5 30 52.5C36.6504 52.5 42.6123 49.5996 46.7285 45H50.625C55.7959 45 60 40.7959 60 35.625V24.375C60 19.2041 55.7959 15 50.625 15H46.7285C42.6123 10.4004 36.6504 7.5 30 7.5ZM39.375 18.75H50.625C53.7305 18.75 56.25 21.2695 56.25 24.375V35.625C56.25 38.7305 53.7305 41.25 50.625 41.25H28.125C31.2305 41.25 33.75 38.7305 33.75 35.625V24.375C33.75 21.2695 36.2695 18.75 39.375 18.75ZM3.75 22.5H7.5L9.46289 32.3438L11.792 22.5H14.4141L16.7725 32.3731L18.75 22.5H22.5L18.75 37.5H15L13.125 30L11.25 37.5H7.5L3.75 22.5ZM28.125 22.5C29.165 22.5 30 23.335 30 24.375C30 25.415 29.165 26.25 28.125 26.25C27.085 26.25 26.25 25.415 26.25 24.375C26.25 23.335 27.085 22.5 28.125 22.5ZM37.5 22.5V37.5H41.25V33.75H45V30H41.25V26.25H45V22.5H37.5ZM50.625 22.5C49.585 22.5 48.75 23.335 48.75 24.375C48.75 25.415 49.585 26.25 50.625 26.25C51.665 26.25 52.5 25.415 52.5 24.375C52.5 23.335 51.665 22.5 50.625 22.5ZM26.25 30H30V37.5H26.25V30ZM48.75 30V37.5H52.5V30H48.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/i3.8f45cca394c5fb1384bf2982956b9458.svg";
export { ForwardRef as ReactComponent };